import { Suspense } from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import Layout from './components/Layout'
import ProtectedRoute from './components/ProtectedRoute'
import LoadingIcon from './components/LoadingIcon'
import { ToastProvider } from './components/Toast'
import { useAuth } from './contexts/AuthContext'
import { isMarketingSite } from './config/siteMode'
import { learningRoutes } from './routes/learningRoutes'
import {
    PipelineBoard,
    CandidatesPage,
    SharedCandidatesPage,
    CandidateDetailPage,
    CandidatePrintPage,
    ShortlistPage,
    TalentPoolPage,
    VacanciesPage,
    VacancyDetailPage,
    VacancyImportPage,
    RequisitionsPage,
    RequisitionCreatePage,
    RequisitionDetailPage,
    TestsPage,
    JobProfilesPage,
    JobProfileDetailPage,
    JobProfileComparePage,
    OffersPage,
    ProcessPage,
    AnalyticsPage,
    CabinetPage,
    StartCenterPage,
    HomePage,
    OffboardingHandoverPage,
    WikiPage,
    TestDraftReviewPage,
    TeamBuilderPage,
    WorkflowStudioPage,
    EmployeesPage,
    EmployeeDetailPage,
    PersonnelFilePage,
    TimesheetPage,
    DocumentsPage,
    OrgChartPage,
    ITAdminPage,
    ExecutivePage,
    MyTeamPage,
    TeamTimesheetPage,
    WorkSchedulesPage,
    TeamPaymentsPage,
    PaymentTasksPage,
    TmaShell,
    CEODashboard,
    ExchangeDashboard,
    SenateOpsDashboard,
    StaleOrdersPage,
    MarketingPage,
    MarketingChannelPage,
    Ps2BotPage,
    Ps2ReviewStudioPage,
    RBACPage,
    FeatureFlags,
    LegalTemplates,
    WorkflowHistory,
    HHSettingsPage,
    HHResponsesPage,
    HHResumeSearchPage,
    HHMessengerPage,
    HHVacancyStatsPage,
    SigningRequestsPage,
    SupportInbox,
    SupportCreate,
    SupportTicket,
    SupportBoard,
    SupportAnswers,
    ResumeScraperPage,
    TimeOffPage,
    AssetsPage,
    AssetDetailPage,
    KeysPage,
    KeyDetailPage,
    InventoryVisibilityPage,
    BenefitsPage,
    OnboardingDashboardPage,
    OnboardingPathsPage,
    OKRPage,
    FingerprintListPage,
    StyleGuidePage,
    BusinessProcessesPage,
    ApiDocsPage,
    SetPasswordPage,
    TelegramCallbackPage,
    OAuthConsentPage,
    FingerprintWizardPage,
    SpansOfControlPage,
    SkillsFootprintPage,
    EcosystemPartnersPage,
    PartnersListPage,
    PartnerDetailPage,
    PartnerDeletionRequestsPage,
    PartnerMergeRequestsPage,
    PartnerTouchDuplicatesPage,
    PartnerGeoLeadsPage,
    ProductCatalogPage,
    PartnerPlansPage,
    PartnersAnalyticsPage,
    PartnersImportPage,
    PartnerAttributionAuditPage,
    PartnerAnalyticsHubPage,
    PartnerSlaAdminPage,
    PartnerSegmentsAdminPage,
    PartnerSearchPage,
    PartnerMeetingsJournalPage,
    PartnerMeetingsDashboardPage,
    PartnerFinancePage,
    PartnerFunnelStatsPage,
    PartnerTouchPlanPage,
    PartnerPlanGapPage,
    PartnerTasksPage,
    PartnerHomePage,
    PartnerExecPage,
    PartnerTeamPage,
    PartnerCockpitPage,
    PartnerNetworkTreePage,
    PartnerTeamComparePage,
    OKKPage,
    OkmPage,
    OwnerPanelPage,
    PartnerLibraryPage,
    LibraryDocFormPage,
    LibraryDocEditorPage,
    LibraryDocFromTemplatePage,
    LibrarySendEmailPage,
    BehaviorsPage,
    QuarterlyGovernancePage,
    KudosPage,
    PeopleAnalyticsPage,
    InboxPage,
    ProjectsPage,
    ProjectDetailPage,
    WorkflowsPage,
    WorkflowRunDetailPage,
    RewardsPage,
    InternalJobsPage,
    ReferralsPage,
    ReviewsPage,
    HRLifecycleDashboard,
    OffboardingsPage,
    CalendarPage,
    DeptHeadDashboard,
    ManagerDashboard,
    ManagerTeamPage,
    MyColleaguesPage,
    MyTrackPage,
    TeamTestResultsPage,
    TeamLearningPage,
    ContractorsPage,
    ContractorDetailPage,
    ContractorCabinetPage,
    DepartmentContractorTasksPage,
    AdBudgetTopupsPage,
    AdminModulesPage,
    OrganizationsAdminPage,
    AdminWatchers,
    AdminColdStart,
    AdminClaudePluginsPage,
    AdminAiDraftsInbox,
    AdminDSARRequests,
    AdminDSARRequestDetail,
    AdminTerminationReviews,
    AdminTerminationReviewDetail,
    ComplianceOverviewPage,
    CandidatePortalPage,
    OfferSigningPage,
    AIStudioPage,
    OfferApprovalsPage,
    IntegrationHubPage,
    HeadcountPlanningPage,
    ExpensesPage,
    FinanceArticlesPage,
    FinanceJournalImportPage,
    FinanceOfficePaybackPage,
    FinanceOperationsPage,
    FinanceAllocationQueuePage,
    FinanceAnalyticsPage,
    FinanceFxRatesPage,
    FinancePurchasesPage,
    SystemCostsPage,
    SecurityDashboardPage,
    AgentConsolePage,
    AgentTaskBoardPage,
    AiWatchPage,
    SandboxPage,
    SandboxExperimentPage,
    TargetManagement,
    PublicCareersLanding,
    ProductLandingPage,
    LandingLegalPage,
    MarketingSiteRoutes,
    InterviewBookPage,
    CandidateStatusPage,
    CandidateCabinetPage,
    PublicBookingPage,
    BookingManagePage,
    WikiTestPage,
    TrackOutcomesPage,
} from './routes/lazyPages'
import HomeRedirect from './components/HomeRedirect'

// Lazy-loaded pages: separate chunks, eager only for Dashboard.
import Dashboard from './pages/Dashboard'

/** Spinner while a lazy chunk is loading */
function PageLoader() {
    return (
        <div
            style={{
                minHeight: '40vh',
                fontSize: '0.938rem'
            }}
            className='flex items-center justify-center color-blue fw-600 gap-8'>
            <LoadingIcon status="PROCESSING" size={20} />{isMarketingSite ? 'Loading…' : 'Загрузка…'}
        </div>
    );
}

export default function App() {
    const { user, hasPermission } = useAuth()

    // Публичный сайт onboardix.com (VITE_SITE_MODE=marketing) живёт на
    // собственном дереве маршрутов: корень отдаёт лендинг, рабочие маршруты
    // не монтируются вовсе. Ветка стоит ЯВНО по режиму сборки, а не по хосту.
    if (isMarketingSite) {
        return (
            <Suspense fallback={<PageLoader />}>
                <MarketingSiteRoutes />
            </Suspense>
        )
    }

    return (
        <ToastProvider>
        <Suspense fallback={<PageLoader />}>
            <Routes>
                {/* ── Public route: Candidate Test Portal (no auth, no sidebar) ── */}
                <Route path="test/:token" element={<CandidatePortalPage />} />
                <Route path="offer-signing/:token" element={<OfferSigningPage />} />
                <Route path="careers" element={<PublicCareersLanding />} />
                <Route path="careers/:vacancyId" element={<PublicCareersLanding />} />
                {/* Публичный продающий лендинг (B2B). Без auth — bypass в main.jsx AuthGate. */}
                <Route path="product" element={<ProductLandingPage />} />
                <Route path="privacy" element={<LandingLegalPage />} />
                <Route path="offer" element={<LandingLegalPage />} />
                <Route path="interview-book/:token" element={<InterviewBookPage />} />
                <Route path="apply/:token" element={<CandidateStatusPage />} />
                {/* Кабинет кандидата по ссылке (#6811): без входа — bypass в main.jsx AuthGate.
                    Ровно один сегмент токена; кабинет сотрудника `/cabinet` живёт в Layout. */}
                <Route path="cabinet/:token" element={<CandidateCabinetPage />} />
                {/* Запись гостя на встречу к сотруднику. Без auth — bypass в main.jsx AuthGate.
                    Статический сегмент `manage` React Router предпочитает динамическому `:pageSlug`. */}
                <Route path="meet/:orgSlug/manage/:token" element={<BookingManagePage />} />
                <Route path="meet/:orgSlug/:pageSlug" element={<PublicBookingPage />} />
                <Route path="meet/:orgSlug/:pageSlug/:eventSlug" element={<PublicBookingPage />} />
                {/* Публичная справка по REST API (docuseal-style). Без auth. */}
                <Route path="api-docs" element={<ApiDocsPage />} />
                {/* Приглашение по ссылке: человек задаёт себе пароль до первого входа. */}
                <Route path="set-password" element={<SetPasswordPage />} />
                {/* Возврат из Telegram: меняем код на сессию и уводим в систему. */}
                <Route path="auth/telegram/callback" element={<TelegramCallbackPage />} />
                {/* Согласие на подключение Claude/ChatGPT (#6530): без входа — форма входа, затем этот экран. */}
                <Route path="oauth/consent" element={<OAuthConsentPage />} />

                {/* ── Telegram Mini App entry — Phase 6 PR 6.1. ──
                    Auth идёт через `window.Telegram.WebApp.initData`
                    (TmaProvider в main.jsx). Никаких ProtectedRoute / Layout —
                    обёртка собственная, mobile-first, 3 tab'а. */}
                <Route path="tma" element={<TmaShell />} />
                <Route path="tma/*" element={<TmaShell />} />

                {/* ── Authenticated but chrome-less: Wiki Test Runner ──
                    JWT required (rendered only when AuthGate sees a logged-in
                    user), but no Layout sidebar — mirrors the candidate portal
                    pattern so the employee is focused on the test. Opened from
                    ArticleViewer via <a target="_blank">. */}
                <Route path="wiki-test/:articleId" element={<WikiTestPage />} />

                <Route path="candidates/:candidateId/print" element={<CandidatePrintPage />} />

                <Route element={<Layout />}>
                    <Route index element={<HomeRedirect />} />
                    <Route path="dashboard" element={<HomeRedirect forceDashboard />} />
                    <Route path="pipeline" element={<ProtectedRoute moduleKey="pipeline"><PipelineBoard /></ProtectedRoute>} />
                    <Route path="pipeline/:candidateId" element={<ProtectedRoute moduleKey="pipeline"><PipelineBoard /></ProtectedRoute>} />
                    <Route path="candidates" element={<ProtectedRoute moduleKey="candidates"><CandidatesPage /></ProtectedRoute>} />
                    <Route path="candidates/shared-with-me" element={<ProtectedRoute moduleKey="candidates"><SharedCandidatesPage /></ProtectedRoute>} />
                    <Route path="candidates/:candidateId" element={<ProtectedRoute moduleKey="candidates"><CandidateDetailPage /></ProtectedRoute>} />
                    <Route path="shortlist" element={<ProtectedRoute moduleKey="shortlist"><ShortlistPage /></ProtectedRoute>} />
                    <Route path="talent-pool" element={<ProtectedRoute moduleKey="talent-pool"><TalentPoolPage /></ProtectedRoute>} />
                    <Route path="vacancies" element={<ProtectedRoute moduleKey="vacancies"><VacanciesPage /></ProtectedRoute>} />
                    <Route path="vacancies/import" element={<ProtectedRoute moduleKey="vacancies"><VacancyImportPage /></ProtectedRoute>} />
                    <Route path="vacancies/:vacancyId" element={<ProtectedRoute moduleKey="vacancies"><VacancyDetailPage /></ProtectedRoute>} />
                    <Route path="requisitions" element={<ProtectedRoute moduleKey="requisitions"><RequisitionsPage /></ProtectedRoute>} />
                    <Route path="requisitions/new" element={<ProtectedRoute moduleKey="requisitions"><RequisitionCreatePage /></ProtectedRoute>} />
                    <Route path="requisitions/:id" element={<ProtectedRoute moduleKey="requisitions"><RequisitionDetailPage /></ProtectedRoute>} />
                    <Route path="tests" element={<ProtectedRoute moduleKey="tests"><TestsPage /></ProtectedRoute>} />
                    <Route path="job-profiles" element={<ProtectedRoute moduleKey="job-profiles"><JobProfilesPage /></ProtectedRoute>} />
                    <Route path="job-profiles/compare" element={<ProtectedRoute moduleKey="job-profiles"><JobProfileComparePage /></ProtectedRoute>} />
                    <Route path="job-profiles/:id" element={<ProtectedRoute moduleKey="job-profiles"><JobProfileDetailPage /></ProtectedRoute>} />
                    <Route path="offers" element={<ProtectedRoute moduleKey="offers"><OffersPage /></ProtectedRoute>} />
                    <Route path="process" element={<ProtectedRoute moduleKey="process"><ProcessPage /></ProtectedRoute>} />
                    <Route path="analytics" element={<ProtectedRoute moduleKey="analytics"><AnalyticsPage /></ProtectedRoute>} />

                    <Route path="support" element={<ProtectedRoute moduleKey="support"><SupportInbox /></ProtectedRoute>} />
                    <Route path="support-board" element={<ProtectedRoute moduleKey="support-board"><SupportBoard /></ProtectedRoute>} />
                    <Route path="support/answers" element={<ProtectedRoute moduleKey="support"><SupportAnswers /></ProtectedRoute>} />
                    <Route path="support/new" element={<ProtectedRoute moduleKey="support"><SupportCreate /></ProtectedRoute>} />
                    <Route path="support/:ticketId" element={<ProtectedRoute moduleKey="support"><SupportTicket /></ProtectedRoute>} />
                    <Route path="cabinet" element={<ProtectedRoute moduleKey="cabinet"><CabinetPage /></ProtectedRoute>} />
                    {/* Стартовый центр — персональная страница, как me/*: пункта меню нет,
                        moduleKey не нужен, сервер отдаёт только свой центр. */}
                    <Route path="start" element={<StartCenterPage />} />
                    {/* Главная — общий экран приземления (рубильник home_v1 в HomeRedirect).
                        Как и /start, персональная: moduleKey не нужен, каждый блок
                        берёт данные из ручки со своей проверкой прав. */}
                    <Route path="home" element={<HomePage />} />
                    {/* Режим передачи дел при увольнении — личный кабинет (self-service).
                        Нет ProtectedRoute moduleKey: gate на backend (employee_id check +
                        offboarding checklist existence). Паттерн: /me/learning, /me/documents.
                        Visibility контролируется TERMINATED_WHITELIST в moduleVisibility.js. */}
                    <Route path="offboarding/handover" element={<OffboardingHandoverPage />} />

                    <Route path="wiki" element={<ProtectedRoute moduleKey="wiki"><WikiPage /></ProtectedRoute>} />
                    {/* Legacy-алиас: очередь проверки ответов исторически линковалась как
                        /wiki/review-queue, но реальная страница — /training/review. Держим
                        redirect, чтобы закладки/старые ссылки вели в очередь, а не на дашборд. */}
                    <Route path="wiki/review-queue" element={<Navigate to="/training/review" replace />} />
                    <Route path="wiki/:articleId/test-drafts/review" element={<ProtectedRoute moduleKey="wiki"><TestDraftReviewPage /></ProtectedRoute>} />
                    <Route path="teambuilder" element={<ProtectedRoute moduleKey="teambuilder"><TeamBuilderPage /></ProtectedRoute>} />
                    <Route path="workflows" element={<ProtectedRoute moduleKey="workflows"><WorkflowStudioPage /></ProtectedRoute>} />

                    <Route path="employees" element={<ProtectedRoute moduleKey="employees"><EmployeesPage /></ProtectedRoute>} />
                    <Route path="employees/new" element={<ProtectedRoute moduleKey="employees"><EmployeeDetailPage /></ProtectedRoute>} />
                    <Route path="employees/:employeeId" element={<Navigate to="personnel-file" replace />} />
                    <Route path="employees/:employeeId/personnel-file" element={<ProtectedRoute moduleKey="personnel-file"><PersonnelFilePage /></ProtectedRoute>} />
                    <Route path="employees/:employeeId/edit" element={<Navigate to="../personnel-file" replace />} />
                    <Route path="timesheet" element={<ProtectedRoute moduleKey="timesheet"><TimesheetPage /></ProtectedRoute>} />
                    <Route path="documents" element={<ProtectedRoute moduleKey="documents"><DocumentsPage /></ProtectedRoute>} />
                    <Route path="orgchart" element={<ProtectedRoute moduleKey="orgchart"><OrgChartPage /></ProtectedRoute>} />
                    <Route path="contractors" element={<ProtectedRoute moduleKey="contractors"><ContractorsPage /></ProtectedRoute>} />
                    <Route path="contractors/:contractorId" element={<ProtectedRoute moduleKey="contractors"><ContractorDetailPage /></ProtectedRoute>} />
                    <Route path="department-contractor-tasks" element={<ProtectedRoute moduleKey="department-contractor-tasks"><DepartmentContractorTasksPage /></ProtectedRoute>} />
                    <Route path="contractor-cabinet" element={<ProtectedRoute moduleKey="contractor-cabinet"><ContractorCabinetPage /></ProtectedRoute>} />
                    <Route path="ad-budget" element={<ProtectedRoute moduleKey="ad-budget"><AdBudgetTopupsPage /></ProtectedRoute>} />

                    <Route path="timeoff" element={<ProtectedRoute moduleKey="timeoff"><TimeOffPage /></ProtectedRoute>} />
                    <Route path="assets" element={<ProtectedRoute moduleKey="assets"><AssetsPage /></ProtectedRoute>} />
                    <Route path="assets/new" element={<ProtectedRoute moduleKey="assets"><AssetDetailPage /></ProtectedRoute>} />
                    <Route path="assets/:assetId" element={<ProtectedRoute moduleKey="assets"><AssetDetailPage /></ProtectedRoute>} />
                    <Route path="keys" element={<ProtectedRoute moduleKey="keys"><KeysPage /></ProtectedRoute>} />
                    <Route path="keys/new" element={<ProtectedRoute moduleKey="keys"><KeyDetailPage /></ProtectedRoute>} />
                    <Route path="keys/:keyId" element={<ProtectedRoute moduleKey="keys"><KeyDetailPage /></ProtectedRoute>} />
                    <Route path="inventory-visibility" element={<ProtectedRoute moduleKey="inventory-visibility"><InventoryVisibilityPage /></ProtectedRoute>} />
                    <Route path="benefits" element={<ProtectedRoute moduleKey="benefits"><BenefitsPage /></ProtectedRoute>} />
                    <Route path="onboarding-paths" element={<ProtectedRoute moduleKey="onboarding-paths"><OnboardingPathsPage /></ProtectedRoute>} />
                    <Route path="onboarding-dashboard" element={<ProtectedRoute moduleKey="onboarding-dashboard"><OnboardingDashboardPage /></ProtectedRoute>} />
                    <Route path="calendar" element={<ProtectedRoute moduleKey="calendar"><CalendarPage /></ProtectedRoute>} />

                    <Route path="okr" element={<ProtectedRoute moduleKey="okr"><OKRPage /></ProtectedRoute>} />
                    <Route path="operating-model" element={<ProtectedRoute moduleKey="operating-model"><FingerprintListPage /></ProtectedRoute>} />
                    <Route path="operating-model/:id" element={<ProtectedRoute moduleKey="operating-model"><FingerprintWizardPage /></ProtectedRoute>} />
                    <Route path="spans-of-control" element={<ProtectedRoute moduleKey="spans-of-control"><SpansOfControlPage /></ProtectedRoute>} />
                    <Route path="skills-footprint" element={<ProtectedRoute moduleKey="skills-footprint"><SkillsFootprintPage /></ProtectedRoute>} />
                    <Route path="partners" element={<ProtectedRoute moduleKey="partners"><EcosystemPartnersPage /></ProtectedRoute>} />
                    <Route path="partner-crm" element={<ProtectedRoute moduleKey="partner-crm"><PartnersListPage /></ProtectedRoute>} />
                    <Route path="partner-crm/attribution-audit" element={<ProtectedRoute moduleKey="partner-crm"><PartnerAttributionAuditPage /></ProtectedRoute>} />
                    <Route path="partner-crm/deletion-requests" element={<ProtectedRoute moduleKey="partner-crm"><PartnerDeletionRequestsPage /></ProtectedRoute>} />
                    <Route path="partner-crm/merge-requests" element={<ProtectedRoute moduleKey="partner-crm"><PartnerMergeRequestsPage /></ProtectedRoute>} />
                    <Route path="partner-crm/touch-duplicates" element={<ProtectedRoute moduleKey="partner-crm"><PartnerTouchDuplicatesPage /></ProtectedRoute>} />
                    <Route path="partner-crm/geo-leads" element={<ProtectedRoute moduleKey="partner-crm/geo-leads"><PartnerGeoLeadsPage /></ProtectedRoute>} />
                    <Route path="partner-crm/:partnerId" element={<ProtectedRoute moduleKey="partner-crm"><PartnerDetailPage /></ProtectedRoute>} />
                    <Route path="partner-finance" element={<ProtectedRoute moduleKey="partner-finance"><PartnerFinancePage /></ProtectedRoute>} />
                    <Route path="partner-funnel-stats" element={<ProtectedRoute moduleKey="partner-funnel-stats"><PartnerFunnelStatsPage /></ProtectedRoute>} />
                    <Route path="partner-touch-plan" element={<ProtectedRoute moduleKey="partner-touch-plan"><PartnerTouchPlanPage /></ProtectedRoute>} />
                    <Route path="partner-plan-gap" element={<ProtectedRoute moduleKey="partner-plan-gap"><PartnerPlanGapPage /></ProtectedRoute>} />
                    <Route path="partner-tasks" element={<ProtectedRoute moduleKey="partner-tasks"><PartnerTasksPage /></ProtectedRoute>} />
                    <Route path="partner-home" element={<ProtectedRoute moduleKey="partner-home"><PartnerHomePage /></ProtectedRoute>} />
                    <Route path="partner-exec" element={<ProtectedRoute moduleKey="partner-exec"><PartnerExecPage /></ProtectedRoute>} />
                    <Route path="partner-desk" element={<ProtectedRoute moduleKey="partner-desk"><PartnerCockpitPage /></ProtectedRoute>} />
                    <Route path="partner-network-tree" element={<ProtectedRoute moduleKey="partner-crm"><PartnerNetworkTreePage /></ProtectedRoute>} />
                    <Route path="partner-team-compare" element={<ProtectedRoute moduleKey="partner-team-compare"><PartnerTeamComparePage /></ProtectedRoute>} />
                    <Route path="partner-team" element={<ProtectedRoute moduleKey="partner-team"><PartnerTeamPage /></ProtectedRoute>} />
                    <Route path="partner-products" element={<ProtectedRoute moduleKey="partner-products"><ProductCatalogPage /></ProtectedRoute>} />
                    <Route path="partner-plans" element={<ProtectedRoute moduleKey="partner-plans"><PartnerPlansPage /></ProtectedRoute>} />
                    <Route path="partner-analytics" element={<ProtectedRoute moduleKey="partner-analytics"><PartnersAnalyticsPage /></ProtectedRoute>} />
                    <Route path="partner-import" element={<ProtectedRoute moduleKey="partner-import"><PartnersImportPage /></ProtectedRoute>} />
                    <Route path="partner-analytics-suite" element={<ProtectedRoute moduleKey="partner-analytics-suite"><PartnerAnalyticsHubPage /></ProtectedRoute>} />
                    <Route path="partner-sla-admin" element={<ProtectedRoute moduleKey="partner-sla-admin"><PartnerSlaAdminPage /></ProtectedRoute>} />
                    <Route path="okk" element={<ProtectedRoute moduleKey="okk"><OKKPage /></ProtectedRoute>} />
                    <Route path="okm" element={<ProtectedRoute moduleKey="okm"><OkmPage /></ProtectedRoute>} />
                    <Route path="owner-panel" element={<ProtectedRoute moduleKey="owner-panel"><OwnerPanelPage /></ProtectedRoute>} />
                    <Route path="partner-docs-marketing" element={<ProtectedRoute moduleKey="partner-docs-marketing"><PartnerLibraryPage category="marketing" /></ProtectedRoute>} />
                    <Route path="partner-docs-marketing/new" element={<ProtectedRoute moduleKey="partner-docs-marketing"><LibraryDocFormPage category="marketing" /></ProtectedRoute>} />
                    <Route path="partner-docs-marketing/:docId/edit" element={<ProtectedRoute moduleKey="partner-docs-marketing"><LibraryDocFormPage category="marketing" /></ProtectedRoute>} />
                    <Route path="partner-docs-marketing/:docId/editor" element={<ProtectedRoute moduleKey="partner-docs-marketing"><LibraryDocEditorPage category="marketing" docSubtype="document" /></ProtectedRoute>} />
                    <Route path="partner-docs-marketing/:docId/email" element={<ProtectedRoute moduleKey="partner-docs-marketing"><LibrarySendEmailPage category="marketing" /></ProtectedRoute>} />
                    <Route path="partner-docs-contracts" element={<ProtectedRoute moduleKey="partner-docs-contracts"><PartnerLibraryPage category="contract" /></ProtectedRoute>} />
                    <Route path="partner-docs-contracts/new-template" element={<ProtectedRoute moduleKey="partner-docs-contracts"><LibraryDocEditorPage category="contract" docSubtype="template" /></ProtectedRoute>} />
                    <Route path="partner-docs-contracts/from-template" element={<ProtectedRoute moduleKey="partner-docs-contracts"><LibraryDocFromTemplatePage category="contract" /></ProtectedRoute>} />
                    <Route path="partner-docs-contracts/:docId/edit" element={<ProtectedRoute moduleKey="partner-docs-contracts"><LibraryDocFormPage category="contract" /></ProtectedRoute>} />
                    <Route path="partner-docs-contracts/:docId/editor" element={<ProtectedRoute moduleKey="partner-docs-contracts"><LibraryDocEditorPage category="contract" /></ProtectedRoute>} />
                    <Route path="partner-docs-contracts/:docId/email" element={<ProtectedRoute moduleKey="partner-docs-contracts"><LibrarySendEmailPage category="contract" /></ProtectedRoute>} />
                    <Route path="partner-segments-admin" element={<ProtectedRoute moduleKey="partner-segments-admin"><PartnerSegmentsAdminPage /></ProtectedRoute>} />
                    <Route path="partner-search" element={<ProtectedRoute moduleKey="partner-search"><PartnerSearchPage /></ProtectedRoute>} />
                    <Route path="partner-meetings" element={<ProtectedRoute moduleKey="partner-meetings"><PartnerMeetingsJournalPage /></ProtectedRoute>} />
                    <Route path="partner-meetings-dashboard" element={<ProtectedRoute moduleKey="partner-meetings-dashboard"><PartnerMeetingsDashboardPage /></ProtectedRoute>} />
                    <Route path="behaviors" element={<ProtectedRoute moduleKey="behaviors"><BehaviorsPage /></ProtectedRoute>} />
                    <Route path="quarterly-governance" element={<ProtectedRoute moduleKey="quarterly-governance"><QuarterlyGovernancePage /></ProtectedRoute>} />
                    <Route path="kudos" element={<ProtectedRoute moduleKey="kudos"><KudosPage /></ProtectedRoute>} />
                    <Route path="people-analytics" element={<ProtectedRoute moduleKey="people-analytics"><PeopleAnalyticsPage /></ProtectedRoute>} />

                    <Route path="inbox" element={<ProtectedRoute moduleKey="inbox"><InboxPage /></ProtectedRoute>} />
                    <Route path="projects" element={<ProtectedRoute moduleKey="projects"><ProjectsPage /></ProtectedRoute>} />
                    <Route path="projects/:projectId" element={<ProtectedRoute moduleKey="projects"><ProjectDetailPage /></ProtectedRoute>} />
                    <Route path="workflow" element={<ProtectedRoute moduleKey="workflows"><WorkflowsPage /></ProtectedRoute>} />
                    <Route path="workflow/runs/:runId" element={<ProtectedRoute moduleKey="workflows"><WorkflowRunDetailPage /></ProtectedRoute>} />
                    <Route path="workflow/my-tasks" element={<Navigate to="/inbox?tab=workflow" replace />} />
                    <Route path="internal-jobs" element={<ProtectedRoute moduleKey="internal-jobs"><InternalJobsPage /></ProtectedRoute>} />
                    <Route path="referrals" element={<ProtectedRoute moduleKey="referrals"><ReferralsPage /></ProtectedRoute>} />
                    <Route path="rewards" element={<ProtectedRoute moduleKey="rewards"><RewardsPage /></ProtectedRoute>} />
                    <Route path="reviews" element={<ProtectedRoute moduleKey="reviews"><ReviewsPage /></ProtectedRoute>} />
                    <Route path="hr-lifecycle" element={<ProtectedRoute moduleKey="hr-lifecycle"><HRLifecycleDashboard /></ProtectedRoute>} />
                    <Route path="offboardings" element={<ProtectedRoute moduleKey="offboardings"><OffboardingsPage /></ProtectedRoute>} />
                    <Route path="simulator" element={<Navigate to="/training" replace />} />
                    <Route path="learning-paths" element={<Navigate to="/training" replace />} />
                    <Route path="knowledge" element={<Navigate to="/wiki" replace />} />
                    <Route path="learning-manager" element={<Navigate to="/training" replace />} />

                    <Route path="itadmin" element={<ProtectedRoute moduleKey="itadmin"><ITAdminPage /></ProtectedRoute>} />
                    <Route path="executive" element={<ProtectedRoute moduleKey="executive"><ExecutivePage /></ProtectedRoute>} />
                    <Route path="myteam" element={<ProtectedRoute moduleKey="myteam"><MyTeamPage /></ProtectedRoute>} />
                    <Route path="dept-dashboard" element={<ProtectedRoute moduleKey="dept-dashboard"><DeptHeadDashboard /></ProtectedRoute>} />
                    <Route path="manager-dashboard" element={<ProtectedRoute moduleKey="manager-dashboard"><ManagerDashboard /></ProtectedRoute>} />
                    <Route path="manager-team" element={<ProtectedRoute moduleKey="manager-team"><ManagerTeamPage /></ProtectedRoute>} />
                    <Route path="team-test-results" element={<ProtectedRoute moduleKey="team-test-results"><TeamTestResultsPage /></ProtectedRoute>} />
                    <Route path="team/learning" element={<ProtectedRoute moduleKey="team/learning"><TeamLearningPage /></ProtectedRoute>} />
                    <Route path="kpi-targets" element={<ProtectedRoute moduleKey="kpi-targets"><TargetManagement /></ProtectedRoute>} />
                    <Route path="senate-ops-dashboard" element={<ProtectedRoute moduleKey="senate-ops-dashboard"><SenateOpsDashboard /></ProtectedRoute>} />
                    <Route path="stale-orders" element={<ProtectedRoute moduleKey="stale-orders"><StaleOrdersPage /></ProtectedRoute>} />
                    <Route path="marketing" element={<ProtectedRoute moduleKey="marketing"><MarketingPage /></ProtectedRoute>} />
                    {/* Отдельный ключ модуля, а не "marketing": подрядчику нужен доступ
                        к своему каналу, а к маркетинговой аналитике компании — нет. */}
                    <Route path="marketing/channels/:channelId" element={<ProtectedRoute moduleKey="marketing-channel"><MarketingChannelPage /></ProtectedRoute>} />
                    <Route path="my-colleagues" element={<ProtectedRoute moduleKey="my-colleagues"><MyColleaguesPage /></ProtectedRoute>} />
                    <Route path="my-track" element={<ProtectedRoute moduleKey="my-track"><MyTrackPage /></ProtectedRoute>} />
                    <Route path="ps2-bot" element={<ProtectedRoute moduleKey="ps2-bot"><Ps2BotPage /></ProtectedRoute>} />
                    <Route path="ps2-bot/review" element={<ProtectedRoute moduleKey="ps2-bot"><Ps2ReviewStudioPage /></ProtectedRoute>} />
                    <Route path="team-timesheet" element={<ProtectedRoute moduleKey="team-timesheet"><TeamTimesheetPage /></ProtectedRoute>} />
                    <Route path="work-schedules" element={<ProtectedRoute moduleKey="work-schedules"><WorkSchedulesPage /></ProtectedRoute>} />
                    <Route path="team-payments" element={<ProtectedRoute moduleKey="team-payments"><TeamPaymentsPage /></ProtectedRoute>} />
                    <Route path="payment-tasks" element={<ProtectedRoute moduleKey="payment-tasks"><PaymentTasksPage /></ProtectedRoute>} />
                    {learningRoutes()}

                    {/* Исполнительный директор */}
                    <Route path="ceo" element={<ProtectedRoute moduleKey="ceo"><CEODashboard /></ProtectedRoute>} />
                    <Route path="exchange" element={<ProtectedRoute moduleKey="exchange"><ExchangeDashboard /></ProtectedRoute>} />

                    {/* Администрирование */}
                    <Route path="rbac" element={<ProtectedRoute moduleKey="rbac"><RBACPage /></ProtectedRoute>} />
                    <Route path="flags" element={<ProtectedRoute moduleKey="flags"><FeatureFlags /></ProtectedRoute>} />
                    {/* Legal templates viewer (admin only — backend require_admin).
                        Просмотр 10 markdown-шаблонов подписываемых документов. */}
                    <Route path="legal-templates" element={<ProtectedRoute moduleKey="legal-templates"><LegalTemplates /></ProtectedRoute>} />
                    <Route path="workflow-history" element={<ProtectedRoute moduleKey="workflow-history"><WorkflowHistory /></ProtectedRoute>} />
                    <Route path="hh-settings" element={<ProtectedRoute moduleKey="hh-settings"><HHSettingsPage /></ProtectedRoute>} />
                    <Route path="hh-responses" element={<ProtectedRoute moduleKey="hh-responses"><HHResponsesPage /></ProtectedRoute>} />
                    <Route path="hh-search" element={<ProtectedRoute moduleKey="hh-search"><HHResumeSearchPage /></ProtectedRoute>} />
                    <Route path="hh-messenger" element={<ProtectedRoute moduleKey="hh-messenger"><HHMessengerPage /></ProtectedRoute>} />
                    <Route path="hh-vacancy-stats" element={<ProtectedRoute moduleKey="hh-vacancy-stats"><HHVacancyStatsPage /></ProtectedRoute>} />
                    <Route path="signing" element={<ProtectedRoute moduleKey="signing"><SigningRequestsPage /></ProtectedRoute>} />
                    <Route path="resume-scraper" element={<ProtectedRoute moduleKey="resume-scraper"><ResumeScraperPage /></ProtectedRoute>} />
                    <Route path="ai-studio" element={<ProtectedRoute moduleKey="ai-studio"><AIStudioPage /></ProtectedRoute>} />
                    <Route path="admin-modules" element={<ProtectedRoute moduleKey="admin-modules"><AdminModulesPage /></ProtectedRoute>} />
                    <Route path="track-outcomes" element={<ProtectedRoute moduleKey="track-outcomes"><TrackOutcomesPage /></ProtectedRoute>} />
                    <Route path="admin-organizations" element={<ProtectedRoute moduleKey="admin-organizations"><OrganizationsAdminPage /></ProtectedRoute>} />
                    <Route path="admin/watchers" element={<ProtectedRoute moduleKey="admin/watchers"><AdminWatchers /></ProtectedRoute>} />
                    <Route path="admin/cold-start" element={<ProtectedRoute moduleKey="admin/cold-start"><AdminColdStart /></ProtectedRoute>} />
                    <Route path="admin/claude-plugins" element={<ProtectedRoute moduleKey="admin/claude-plugins"><AdminClaudePluginsPage /></ProtectedRoute>} />
                    <Route path="admin/ai-drafts" element={<ProtectedRoute moduleKey="admin/ai-drafts"><AdminAiDraftsInbox /></ProtectedRoute>} />
                    <Route path="admin/dsar" element={<ProtectedRoute moduleKey="admin/dsar"><AdminDSARRequests /></ProtectedRoute>} />
                    <Route path="admin/dsar/:requestId" element={<ProtectedRoute moduleKey="admin/dsar"><AdminDSARRequestDetail /></ProtectedRoute>} />
                    <Route path="admin/termination-reviews" element={<ProtectedRoute moduleKey="admin/termination-reviews"><AdminTerminationReviews /></ProtectedRoute>} />
                    <Route path="admin/termination-reviews/:reviewId" element={<ProtectedRoute moduleKey="admin/termination-reviews"><AdminTerminationReviewDetail /></ProtectedRoute>} />
                    <Route path="admin/compliance-overview" element={<ProtectedRoute moduleKey="admin/compliance-overview"><ComplianceOverviewPage /></ProtectedRoute>} />
                    <Route path="admin/security" element={<ProtectedRoute moduleKey="admin/security"><SecurityDashboardPage /></ProtectedRoute>} />
                    <Route path="business-processes" element={<ProtectedRoute moduleKey="business-processes"><BusinessProcessesPage /></ProtectedRoute>} />
                    <Route path="style-guide" element={<ProtectedRoute moduleKey="style-guide"><StyleGuidePage /></ProtectedRoute>} />
                    <Route path="offer-approvals" element={<ProtectedRoute moduleKey="offer-approvals"><OfferApprovalsPage /></ProtectedRoute>} />
                    <Route path="integrations" element={<ProtectedRoute moduleKey="integrations"><IntegrationHubPage /></ProtectedRoute>} />
                    <Route path="headcount-planning" element={<ProtectedRoute moduleKey="headcount-planning"><HeadcountPlanningPage /></ProtectedRoute>} />
                    {/* «Мои расходы» отключены до настройки процесса
                        (docs/specs/navigation-redesign-2026-07.md §1): из меню убраны,
                        маршрут закрыт модулем — код и данные остались на месте. */}
                    <Route path="expenses" element={<ProtectedRoute moduleKey="expenses"><ExpensesPage /></ProtectedRoute>} />
                    <Route
                        path="finance-articles"
                        element={(
                            <ProtectedRoute moduleKey="finance-articles">
                                <FinanceArticlesPage />
                            </ProtectedRoute>
                        )}
                    />
                    <Route
                        path="finance-journal-import"
                        element={(
                            <ProtectedRoute moduleKey="finance-journal-import">
                                <FinanceJournalImportPage />
                            </ProtectedRoute>
                        )}
                    />
                    <Route
                        path="finance-office-payback"
                        element={(
                            <ProtectedRoute moduleKey="finance-office-payback">
                                <FinanceOfficePaybackPage />
                            </ProtectedRoute>
                        )}
                    />
                    <Route
                        path="finance-operations"
                        element={(
                            <ProtectedRoute moduleKey="finance-operations">
                                <FinanceOperationsPage />
                            </ProtectedRoute>
                        )}
                    />
                    <Route
                        path="finance-fx-rates"
                        element={(
                            <ProtectedRoute moduleKey="finance-fx-rates">
                                <FinanceFxRatesPage />
                            </ProtectedRoute>
                        )}
                    />
                    <Route
                        path="finance-purchases"
                        element={(
                            <ProtectedRoute moduleKey="finance-purchases">
                                <FinancePurchasesPage />
                            </ProtectedRoute>
                        )}
                    />
                    <Route
                        path="finance-allocation-queue"
                        element={(
                            <ProtectedRoute moduleKey="finance-allocation-queue">
                                <FinanceAllocationQueuePage />
                            </ProtectedRoute>
                        )}
                    />
                    <Route
                        path="finance-analytics"
                        element={(
                            <ProtectedRoute moduleKey="finance-analytics">
                                <FinanceAnalyticsPage />
                            </ProtectedRoute>
                        )}
                    />
                    <Route
                        path="expense-approvals"
                        element={(
                            <ProtectedRoute moduleKey="expense-approvals">
                                <ExpensesPage />
                            </ProtectedRoute>
                        )}
                    />
                    <Route path="system-costs" element={<ProtectedRoute moduleKey="system-costs"><SystemCostsPage /></ProtectedRoute>} />
                    <Route
                        path="ai-watch"
                        element={(
                            <ProtectedRoute moduleKey="ai-watch">
                                <AiWatchPage />
                            </ProtectedRoute>
                        )}
                    />
                    <Route
                        path="sandbox"
                        element={(
                            <ProtectedRoute moduleKey="sandbox">
                                <SandboxPage />
                            </ProtectedRoute>
                        )}
                    />
                    <Route
                        path="sandbox/:experimentKey"
                        element={(
                            <ProtectedRoute moduleKey="sandbox">
                                <SandboxExperimentPage />
                            </ProtectedRoute>
                        )}
                    />
                    <Route
                        path="mission-control"
                        element={(
                            <ProtectedRoute moduleKey="mission-control">
                                <AgentConsolePage />
                            </ProtectedRoute>
                        )}
                    />
                    <Route
                        path="agent-tasks"
                        element={(
                            <ProtectedRoute moduleKey="agent-tasks">
                                <AgentTaskBoardPage />
                            </ProtectedRoute>
                        )}
                    />
                    {/* /messenger route удалён 2026-05-24 — мессенджер через AssistantsMenu drawer. */}

                    <Route path="*" element={<Navigate to="/" replace />} />
                </Route>
            </Routes>
        </Suspense>
        </ToastProvider>
    )
}
